export default __webpack_public_path__ + "static/turn-05e30e54f8e6f039a5c97173e3106a51.png";